import * as React from "react";
import { IProduct } from "../../types/product";
import ProductHero from "../../components/product-details/product-hero/product-hero";
import ProductDescription, {
    IProductDescriptionProps
} from "../../components/product-details/product-description/product-description";
import Tag from "../tag/tag";
// import { IButtonAddToBasketProps } from "../button-add-to-basket/button-add-to-basket";
// import ButtonAddToBasket from "~/components/button-add-to-basket/button-add-to-basket";
// import ProductPrice from "../product-price/product-price";
import { IButtonSkipBookOfTheMonthProps } from "./button-skip-book-of-the-month/button-skip-book-of-the-month";
import classNames from "classnames";
// import CtaButton from "../cta-button/cta-button";
import { pushDetailViewTrackingEvent } from "../../utils/tracking-utils";
import { ProductSignupCtaProps } from "../product-signup-cta/product-signup-cta";
import WorkVariantForm, { WorkVariantProps } from "../work-details/work-variant-form/work-variant-form";
import ArrowLink from "../arrow-link/arrow-link";
import ProductAuthors from "../product-authors/product-authors";
// import InfoSection from "../info-section/info-section";
// import { useSelector } from "react-redux";
// import { IRootState } from "~/store/reducers";
// import { selectIsOutOfStock } from "~/store/reducers/basket/basket-reducer";
// import ErrorMessage from "../error-message/error-message";
import BookReadingModal from "./book-reading-modal/book-reading-modal";
import IconButton from "../icon-button/icon-button";
import AudioModal from "./audio-modal/audio-modal";
import IconLink from "../icon-link/icon-link";
// import { IDiscountOffer } from "~/types/discount-offer";
// import DiscountModal from "./discount-modal/discount-modal";
// import { hasDeclinedDiscountThisOffer } from "~/utils/discount-utils";

export interface IProductDetailsProps
    extends Partial<
            Pick<
                IButtonSkipBookOfTheMonthProps,
                "skipBookOfTheMonthWebApiUrl" | "isSkipBookOfTheMonthAllowed"
            >
        >,
        Partial<Pick<WorkVariantProps, "variants" | "variantsLabel" | "onVariantSelect">>,
        Partial<ProductSignupCtaProps>,
        Pick<
            IProductDescriptionProps,
            | "productDescriptionTab"
            | "productDescriptionShowMoreButton"
            | "productDescriptionShowLessButton"
            | "productSpecificationsTab"
            | "productSpecifications"
            | "productPressSpecificationsTab"
            | "productPressSpecifications"
        > {
    product: IProduct;
    initialVariantIndex?: number;
    primaryPriceLabel: string;
    // secondaryPriceLabel?: string;
    addToBasketLabel?: string;
    bookOfTheMonthAddToBasketLabel?: string;
    bookOfTheMonthSkipLabel?: string;
    ctaLink?: string;
    className?: string;
    vendorListTitle?: string;
    vendorList?: string[];
    readBookLabel?: string;
    readBookPlayerLink?: string;
    listenToBookLabel?: string;
    listenToBookPlayerLink?: string;
    downloadCoverImageLabel?: string;
    downloadCoverImageLink?: string;
    // disableDiscountOfferWebApiUrl: string;
    // showDiscountOfferModal?: boolean;
    // discountOffer?: IDiscountOffer;
}

const ProductDetails: React.FC<IProductDetailsProps> = ({
    product,
    // addToBasketWebApiUrl,
    // skipBookOfTheMonthWebApiUrl,
    // isSkipBookOfTheMonthAllowed,
    // addToBasketLabel,
    // bookOfTheMonthAddToBasketLabel,
    // bookOfTheMonthSkipLabel,
    // ctaLink,
    className,
    variants,
    variantsLabel,
    onVariantSelect,
    initialVariantIndex,
    vendorListTitle,
    vendorList,
    readBookLabel,
    listenToBookLabel,
    readBookPlayerLink,
    listenToBookPlayerLink,
    downloadCoverImageLabel,
    downloadCoverImageLink,
    // showDiscountOfferModal = false,
    // discountOffer,
    // secondaryPriceLabel,
    primaryPriceLabel,
    ...props
}) => {
    const [bookModalOpen, setBookModalOpen] = React.useState(false);
    const [audioModalOpen, setAudioModalOpen] = React.useState(false);
    // const [discountModalOpen, setDiscountModalOpen] = React.useState(false);

    React.useEffect(() => {
        pushDetailViewTrackingEvent({ ...product, trackingList: "Product Details" });
    }, []);

    const baseClass = "product-details";
    const rootClasses = classNames(baseClass, className);

    const hasSignupCta =
        props.productSignupCtaLink && props.productSignupCtaText && props.productSignupCtaTitle;
    const hasVendorList = vendorListTitle && vendorList && vendorList.length > 0;

    const buyingSectionClasses = classNames(`${baseClass}__buying-section`, {
        [`${baseClass}__buying-section--hasSignupPadding`]: hasSignupCta
        // [`${baseClass}__buying-section--hasVendorListAndBasketButton`]: hasVendorList && addToBasketWebApiUrl
    });

    // const isOutOfStock = useSelector((state: IRootState) => selectIsOutOfStock(state, product.productId));

    // const onAddToBasket = () => {
    //     if (!discountOffer) {
    //         return;
    //     }

    //     if (hasDeclinedDiscountThisOffer(discountOffer)) {
    //         return;
    //     }

    //     if (!showDiscountOfferModal) {
    //         return;
    //     }

    //     setDiscountModalOpen(true);
    // };

    return (
        <div className={rootClasses}>
            <div className={`${baseClass}__hero-wrapper`}>
                <ProductHero
                    {...props}
                    imageFallbackSrc={product.imageFallbackSrc}
                    imageSrcSet={product.imageSrcSet}
                    // discount={product.discount}
                    onOpenAudioModal={() => setAudioModalOpen(true)}
                    onOpenBookModal={() => setBookModalOpen(true)}
                    readBookLabel={readBookLabel}
                    readBookPlayerLink={readBookPlayerLink}
                    listenToBookLabel={listenToBookLabel}
                    listenToBookPlayerLink={listenToBookPlayerLink}
                    downloadCoverImageLabel={downloadCoverImageLabel}
                    downloadCoverImageLink={downloadCoverImageLink}
                />
            </div>

            <div className={`${baseClass}__info-grid ${baseClass}__title-container`}>
                <div className={`${baseClass}__action-wrapper`}></div>
                <div className={`${baseClass}__title-wrapper ${baseClass}__info-wrapper`}>
                    {product.status && <Tag type={product.status}>{product.statusLabel}</Tag>}
                    <h1 className={`${baseClass}__title h1-style`}>{product.title}</h1>
                    <ProductAuthors authors={product.authors} className={`${baseClass}__product-authors`} />
                </div>
            </div>

            {readBookPlayerLink && (
                <BookReadingModal
                    playerLink={readBookPlayerLink}
                    isOpen={bookModalOpen}
                    onRequestClose={() => setBookModalOpen(false)}
                />
            )}

            {listenToBookPlayerLink && (
                <AudioModal
                    title={product.title}
                    playerLink={listenToBookPlayerLink}
                    isOpen={audioModalOpen}
                    onRequestClose={() => setAudioModalOpen(false)}
                />
            )}
            <div className={`${baseClass}__info-grid ${baseClass}__content-container`}>
                <div className={`${baseClass}__action-wrapper`}>
                    <div className={`${baseClass}__action-button-wrapper`}>
                        {readBookLabel && readBookPlayerLink && (
                            <IconButton onClick={() => setBookModalOpen(true)} iconId="icon_read">
                                {readBookLabel}
                            </IconButton>
                        )}

                        {listenToBookLabel && listenToBookPlayerLink && (
                            <IconButton onClick={() => setAudioModalOpen(true)} iconId="icon_listen">
                                {listenToBookLabel}
                            </IconButton>
                        )}

                        {downloadCoverImageLabel && downloadCoverImageLink && (
                            <IconLink href={downloadCoverImageLink} iconId="icon_download" target="_blank">
                                {downloadCoverImageLabel}
                            </IconLink>
                        )}
                    </div>
                </div>

                <div className={`${baseClass}__info-wrapper`}>
                    <div className={`${baseClass}__content-wrapper`}>
                        <ProductDescription {...props} productDescription={product.description} />
                        <div className={buyingSectionClasses}>
                            {primaryPriceLabel && (
                                <h3 className={`${baseClass}__vendor-list-title`}>{primaryPriceLabel}</h3>
                            )}
                            {product.primaryPrice && (
                                <p className="product-price__primary-price">{product.primaryPrice}</p>
                            )}

                            {variants &&
                                variants.length > 0 &&
                                onVariantSelect &&
                                initialVariantIndex !== undefined && (
                                    <WorkVariantForm
                                        variants={variants}
                                        variantsLabel={variantsLabel}
                                        onVariantSelect={onVariantSelect}
                                        initialValues={{
                                            selectedVariant: String(initialVariantIndex)
                                        }}
                                    />
                                )}

                            {/* <ProductPrice
                                {...props}
                                priceType={product.priceType}
                                primaryPrice={product.primaryPrice}
                                secondaryPrice={product.secondaryPrice}
                                isCurrentBookOfTheMonth={product.isCurrentBookOfTheMonth}
                                bookOfTheMonthStatusLabel={product.bookOfTheMonthStatusLabel}
                                status={product.status}
                            >
                                {ctaLink && <CtaButton isLarge link={ctaLink} />}
                                {product.isCurrentBookOfTheMonth ? (
                                    <>
                                        {addToBasketWebApiUrl && (
                                            <>
                                                <ButtonAddToBasket
                                                    className="product-price__buy-button"
                                                    addToBasketWebApiUrl={addToBasketWebApiUrl}
                                                    productId={product.productId}
                                                    trackingList="Product Details"
                                                    isLarge
                                                    onAdd={onAddToBasket}
                                                >
                                                    {bookOfTheMonthAddToBasketLabel}
                                                </ButtonAddToBasket>
                                                {isOutOfStock.error && isOutOfStock.value && (
                                                    <ErrorMessage
                                                        errorSeverity="error"
                                                        errorMessage={isOutOfStock.error}
                                                    />
                                                )}
                                            </>
                                        )}
                                        {skipBookOfTheMonthWebApiUrl && (
                                            <ButtonSkipBookOfTheMonth
                                                className="product-price__botm-skip-button"
                                                skipBookOfTheMonthWebApiUrl={skipBookOfTheMonthWebApiUrl}
                                                isSkipBookOfTheMonthAllowed={isSkipBookOfTheMonthAllowed}
                                                productId={product.productId}
                                                isLarge
                                                isInverted
                                            >
                                                {bookOfTheMonthSkipLabel}
                                            </ButtonSkipBookOfTheMonth>
                                        )}
                                    </>
                                ) : (
                                    addToBasketWebApiUrl && (
                                        <>
                                            <ButtonAddToBasket
                                                className="product-price__buy-button"
                                                addToBasketWebApiUrl={addToBasketWebApiUrl}
                                                productId={product.productId}
                                                trackingList="Product Details"
                                                isLarge
                                                onAdd={onAddToBasket}
                                            >
                                                {addToBasketLabel}
                                            </ButtonAddToBasket>
                                            {isOutOfStock.error && isOutOfStock.value && (
                                                <ErrorMessage
                                                    errorSeverity="error"
                                                    errorMessage={isOutOfStock.error}
                                                />
                                            )}
                                        </>
                                    )
                                )}
                                {(product.stockStatusLabel || product.stockStatusDetails) && (
                                    <InfoSection
                                        iconId="32_information"
                                        label={product.stockStatusLabel}
                                        details={product.stockStatusDetails}
                                        status={
                                            product.stockStatus
                                                ? ProductStockStatusEnum[product.stockStatus]
                                                : undefined
                                        }
                                    />
                                )}
                                {(product.deliveryLabel || product.deliveryDetails) && (
                                    <InfoSection
                                        iconId="32_truck-in-motion"
                                        label={product.deliveryLabel}
                                        details={product.deliveryDetails}
                                    />
                                )}
                            </ProductPrice> */}

                            {/* {showDiscountOfferModal && discountOffer && (
                                <DiscountModal
                                    isOpen={discountModalOpen}
                                    setOpen={setDiscountModalOpen}
                                    addToBasketWebApiUrl={addToBasketWebApiUrl}
                                    discount={discountOffer}
                                    secondaryPriceLabel={secondaryPriceLabel}
                                    {...props}
                                />
                            )} */}

                            {hasVendorList && (
                                <>
                                    <h3 className={`${baseClass}__vendor-list-title`}>{vendorListTitle}</h3>
                                    <ul className={`${baseClass}__vendor-list`}>
                                        {vendorList?.map((item, index) => (
                                            <li className={`${baseClass}__vendor`} key={index}>
                                                {item.includes("</a>") ? (
                                                    <ArrowLink link={item} />
                                                ) : (
                                                    <span dangerouslySetInnerHTML={{ __html: item }} />
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductDetails;
